import React, { useEffect, useState } from "react";
import "./Edit_offcanvas.css";
import Select from "react-select";
import { Button, Form, Offcanvas } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import successAnimation from "../../../../../../animation/success_lottie/Success_lottie.json";
import Blue_btn from "../../../../../../common_components/common_btn/blue_btn/Blue_btn";
import Blue_border_button from "../../../../../../common_components/common_btn/blue_border_button/Blue_border_button";
import Success_modal from "../../../../../../common_components/common_modal/success_modal/Success_modal";
import { useDispatch } from "react-redux";
import {
  GetAll,
  GetSingle,
  Update,
} from "../../../../../../../features/admin/masters/country/Slice";
import { useForm } from "react-hook-form";
import classNames from "classnames";

function Edit_offcanvas({
  show,
  showError,
  setShowError,
  setShow,
  setSuccess,
  setErr,
  handleClose,
  setShowRejectModal,
}) {
  const [modalSuccessShow, setModalsuccessShow] = useState(false);

  const dispatch = useDispatch();
  const [defaultValues, setDefaultValues] = useState({});
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: "",
    },
  });

  const onSubmit = async (data) => {
    try {
      const res = await dispatch(Update({ id: data.id, data }));

      if (res.meta?.requestStatus === "fulfilled") {
        dispatch(GetAll());

        setModalsuccessShow(true); // ✅ SHOW SUCCESS MODAL
        setShow(false); // close offcanvas
        setSuccess(true); // optional parent flag
      } else {
        setShow(false);
        setShowRejectModal(true);
      }
    } catch (error) {
      setShow(false);
      setShowRejectModal(true);
    }
  };

  useEffect(() => {
    if (modalSuccessShow) {
      const timer = setTimeout(() => {
        setModalsuccessShow(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [modalSuccessShow]);

  const GetData = async (id) => {
    try {
      const res = await dispatch(GetSingle(id));
      setDefaultValues({
        id: res?.payload?.data?.id,
        name: res?.payload?.data?.name,
      });
    } catch (error) {
      console.error(error);
      setShow(false);
      setErr(true);
    }
  };

  useEffect(() => {
    if (show) {
      GetData(show);
    }
  }, [show]);

  useEffect(() => {
    if (defaultValues?.id) {
      reset(defaultValues);
    }
  }, [defaultValues, reset]);

  return (
    <>
      <Offcanvas
        show={show}
        onHide={handleClose}
        placement="end"
        className="view_application_canvas common_offcanvas"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Edit</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="form_holder">
            <Form onSubmit={handleSubmit(onSubmit)}>
              <div className="row">
                {/* Full Name */}
                <div className="col-md-4 mb-3">
                  <Form.Group className="form_field">
                    <Form.Label>Name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Name"
                      className={classNames("", { "is-invalid": errors?.name })}
                      {...register("name", {
                        required: "Name is required",
                        maxLength: {
                          value: 100,
                          message: "Name cannot exceed 100 characters",
                        },
                        pattern: {
                          value: /^[A-Za-z]+(?:\s[A-Za-z]+)*$/,
                          message:
                            "Name should contain only letters and single spaces (no leading or trailing spaces)",
                        },
                      })}
                    />
                    {errors?.name && (
                      <Form.Text className="text-danger">
                        {errors?.name?.message}
                      </Form.Text>
                    )}
                    {showError && (
                      <Form.Text className="text-danger">{showError}</Form.Text>
                    )}
                  </Form.Group>
                </div>
              </div>

              <div className="btn_holder">
                {/* <Blue_btn btn_text={"Cancle"} /> */}
                <Blue_border_button button_text={"Save"} type="submit" />
              </div>
            </Form>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
      <Success_modal
        show={modalSuccessShow}
        onHide={() => setModalsuccessShow(false)}
        message_text={"Operation was successful!"}
        animationData={successAnimation}
      />
    </>
  );
}

export default Edit_offcanvas;
